import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

export interface UserProfile {
  username: string;
  group: string;
  email: string;
  job_title: string;
  first_name: string;
  surname: string;
}

export enum ContextAction {
  CREATED = 'ContextCreated',
  TERMINATED = 'ContextTerminated',
}

export interface ApplicationNotification {
  type: string;
  payload?: any;
}

export interface INotificationBroker {
  emit(notification: ApplicationNotification): void;

  on(): Observable<ApplicationNotification>;
}

export interface IViewOrderedCollectionItem {
  display_order: number;
}

export interface IViewOrderedCollectionItemFormGroup {
  display_order: FormControl<number>;
}

export interface IDataSerializer<TInput, TOutput> {
  serialize(input: TInput): TOutput;
}
